import { ButtonSecondary, Colors, Icon, Text } from '@amelio/ui-library';

import { useAmelioTranslations } from '@/hooks';

interface AgendaAiBannerProps {
    onGenerate: () => void;
    isGenerating: boolean;
    disabled?: boolean;
}

export const AgendaAiBanner = ({
    onGenerate,
    isGenerating,
    disabled = false,
}: AgendaAiBannerProps) => {
    const { t } = useAmelioTranslations();

    return (
        <div
            className={
                'shadow-ai-glow mt-4 flex flex-wrap items-center justify-between gap-4 rounded-xl bg-gradient-to-r from-teal-500 via-purple-700 to-purple-900 p-4'
            }
            data-testid={'meeting-agenda-ai-banner'}
        >
            <div className={'flex items-center gap-3'}>
                <div
                    className={
                        'flex h-10 w-10 shrink-0 animate-pulse items-center justify-center rounded-lg bg-white/15 backdrop-blur-sm'
                    }
                >
                    <Icon
                        name={'lucide-sparkles'}
                        size={'lg'}
                        color={Colors.WHITE}
                    />
                </div>

                <div className={'flex flex-col gap-1'}>
                    <Text
                        size={'default'}
                        weight={'semibold'}
                        color={Colors.WHITE}
                    >
                        {t('meetingAgenda.aiBannerTitle')}
                    </Text>

                    <Text
                        size={'small'}
                        color={Colors.WHITE}
                        className={'opacity-90'}
                    >
                        {t('meetingAgenda.aiBannerDescription')}
                    </Text>
                </div>
            </div>

            {/* The library merges these classes over the button's own size, colour and hover. */}
            <ButtonSecondary
                onClick={onGenerate}
                loading={isGenerating}
                disabled={disabled}
                dataTestId={'generate-meeting-plan-button'}
                className={'rounded-lg px-5 py-3 text-sm text-indigo-950 hover:scale-100'}
            >
                {t('meetingAgenda.generateMeetingPlan')}
            </ButtonSecondary>
        </div>
    );
};

export default AgendaAiBanner;
